<div class="flex flex-wrap items-center gap-1.5">
  <span *ngFor="let e of etiquetas" class="kb-etiqueta" [ngStyle]="estilo(e)">
    {{ e }}
    <button *ngIf="editable" type="button" class="kb-etiqueta-quitar" (click)="quitar.emit(e)" [attr.aria-label]="'Quitar la etiqueta ' + e">
      <i class="fas fa-times"></i>
    </button>
  </span>
  <span *ngIf="!etiquetas.length && !abierto" class="text-xs text-muted-foreground">Sin etiquetas</span>

  <ng-container *ngIf="editable">
    <button *ngIf="!abierto" type="button" class="kb-chip" (click)="abrir()"><i class="fas fa-plus text-xs"></i> Etiqueta</button>

    <div *ngIf="abierto" class="relative">
      <input type="text" class="kb-input h-8 w-52" placeholder="Escribe para buscar o crear" aria-label="Etiqueta"
        [ngModel]="texto" (ngModelChange)="escribir($event)" (keydown)="teclas($event)" autocomplete="off" maxlength="40">
      <ul class="kb-sugerencias" role="listbox">
        <li *ngFor="let s of sugerencias" role="option">
          <button type="button" class="kb-sugerencia" (click)="elegir(s.nombre)">
            <span class="kb-punto" [style.backgroundColor]="s.color"></span>{{ s.nombre }}
          </button>
        </li>
        <li *ngIf="puedeCrear" role="option">
          <button type="button" class="kb-sugerencia kb-sugerencia-crear" [disabled]="creando" (click)="crear()">
            <i class="fas fa-plus text-xs"></i> Crear «{{ texto.trim() }}»
          </button>
        </li>
        <li *ngIf="!sugerencias.length && !puedeCrear && !buscando" class="px-3 py-2 text-xs text-muted-foreground">Escribe el nombre de la etiqueta.</li>
        <li *ngIf="error" class="px-3 py-2 text-xs kb-texto-alerta">{{ error }}</li>
        <li class="border-t border-border"><button type="button" class="kb-sugerencia text-muted-foreground" (click)="cerrar()">Cancelar</button></li>
      </ul>
    </div>
  </ng-container>
</div>
